export type TOutputFormat = 'png' | 'jpeg';

export interface ICropOptions {
    title: string;
    description: string;
    maintainAspectRatio: boolean;
    aspectRatio: number;
    resizeToWidth: number;
    resizeToHeight: number;
    cropperMinWidth: number;
    cropperMinHeight: number;
    cropperMaxWidth: number;
    cropperMaxHeight: number;
    onlyScaleDown: boolean;
}

export interface IAvatarOptions {
    title: string;
    description: string;
    resizeToWidth: number;
    resizeToHeight: number;
}

export interface ICropperDialogData {
    cropOptions: ICropOptions;
    avatarOptions: IAvatarOptions;
    useAvatarStep: boolean;
    outputFormat: TOutputFormat;
    data: any;
}

export const DEFAULT_CROP_OPTIONS: ICropOptions = {
    title: '',
    description: '',
    maintainAspectRatio: false,
    aspectRatio: 1,
    resizeToWidth: 0,
    resizeToHeight: 0,
    cropperMinWidth: 0,
    cropperMinHeight: 0,
    cropperMaxWidth: 0,
    cropperMaxHeight: 0,
    onlyScaleDown: true,
};

export const DEFAULT_AVATAR_OPTIONS: IAvatarOptions = {
    title: '',
    description: '',
    resizeToWidth: 128,
    resizeToHeight: 128,
};

export const DEFAULT_CROPPER_DIALOG_DATA: ICropperDialogData = {
    cropOptions: DEFAULT_CROP_OPTIONS,
    avatarOptions: null,
    useAvatarStep: false,
    outputFormat: 'png',
    data: null,
};

export const allowedMimeTypes = ['image/jpeg', 'image/pjpeg', 'image/png', 'image/x-png'];

export const guessOutputFormat = (fileName: string): TOutputFormat => {
    const parts = fileName?.split('.') ?? ['png'];
    const ext = parts[parts.length - 1];
    return ext !== 'png' ? 'jpeg' : 'png';
};
